import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import inventoryProductsTemplate from './inventoryProducts.template.html';

export default angular
  .module('books.ui.inventoryProducts', [csmCommonWeb, booksService])
  .service('InventoryProducts', inventoryProductsService).name;

/*******************************************************************************
 * Service: InventoryProducts
 *
 * Display a modal dialog with a grid showing all item options for the given
 * inventory item
 *******************************************************************************/
/* @ngInject */
function inventoryProductsService(
  $q,
  $uibModal,
  BooksSvc,
  DGProductPurchase,
  uiGridConstants
) {
  function inventoryProductsController(
    $uibModalInstance,
    $scope,
    CommonUIGridTemplates,
    InventoryOptionsColumn,
    prod,
    Tools
  ) {
    /*------------------------------------*/
    /* Product name displayed in the view */
    /*------------------------------------*/
    $scope.prodName = prod.name;

    /*-------------------------------*/
    /* Inventory Options Grid Config */
    /*-------------------------------*/
    var mInventoryColumn = new InventoryOptionsColumn();
    $scope.optsGrid = {
      enableColumnMenus: false,
      enableCellEditOnFocus: true,
      enableColumnMenus: false,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      columnDefs: [
        mInventoryColumn,
        {
          field: 'cost',
          maxWidth: 80,
          enableCellEdit: true,
          cellFilter: 'currency',
          editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
          precision: 2
        },
        {
          field: 'qty',
          maxWidth: 80,
          enableCellEdit: true,
          editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
          cellFilter: 'number'
        },
        {
          field: 'subTotal',
          maxWidth: 80,
          enableCellEdit: false,
          cellFilter: 'currency',
          displayName: 'subtotal'
        },
        {
          field: 'tax',
          maxWidth: 80,
          enableCellEdit: true,
          cellFilter: 'currency',
          editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
          precision: 2
        },
        {
          field: 'freight',
          maxWidth: 80,
          enableCellEdit: true,
          cellFilter: 'currency',
          editableCellTemplate: CommonUIGridTemplates.CELL_NUMBER_INPUT,
          precision: 2
        },
        {
          field: 'total',
          maxWidth: 80,
          enableCellEdit: false,
          cellFilter: 'currency'
        }
      ],
      data: []
    };

    /*****************************************************************************
     * add */
    /**
     * Handler for the 'Ok' button. Upon valid item(s), dismiss the dialog with an
     * array of DGProductPurchase items.
     *****************************************************************************/
    $scope.add = function () {
      /*---------------------------------------------------------------*/
      /* Check for valid data by seeing if the add button is available */
      /*---------------------------------------------------------------*/
      if ($scope.disableAddButton()) return;

      /*------------------------------------------*/
      /* Array of items to resolve the modal with */
      /*------------------------------------------*/
      var items = [];

      $scope.optsGrid.data.forEach(function (dgItem) {
        if (dgItem.total > 0) items.push(dgItem);
      });

      $uibModalInstance.close(items);
    };

    /*****************************************************************************
     * disableAddButton */
    /**
     * Returns true no grid item has a total greater than 0, indicating the 'Ok'
     * button should be disabled.
     *
     * @return         Boolean indicating if the button should be disabled
     *****************************************************************************/
    $scope.disableAddButton = function () {
      return !$scope.optsGrid.data.some(function (dgItem) {
        return dgItem.total > 0;
      });
    };

    /*****************************************************************************
     * init */
    /**
     * Make a service call to retrieve all product options and populate the grid.
     *
     * @return         Boolean indicating if the button should be disabled
     *****************************************************************************/
    $scope.init = function () {
      BooksSvc.getInventoryProducts(prod.id).then(function (resp) {
        /*-----------------------*/
        /* Find the base product */
        /*-----------------------*/
        var baseProduct = resp.data
          .filter(function (p) {
            return p.options.length == 0;
          })
          .shift();

        /*-------------------------------*/
        /* Remove the base from the list */
        /*-------------------------------*/
        resp.data.splice(resp.data.indexOf(baseProduct), 1);

        /*-------------------------------------------*/
        /* Set remaining inventory combinations if   */
        /* any utilizing the DGProductPurchase class */
        /*-------------------------------------------*/
        $scope.optsGrid.data = resp.data.map(function (ip) {
          return new DGProductPurchase(ip, true, prod);
        });

        /*----------------------------------------------------------*/
        /* There are multiple inventory options, compile the master */
        /* option information from all the InventoryProductOption   */
        /* items to update the inventory column                     */
        /*----------------------------------------------------------*/
        if ($scope.optsGrid.data.length > 0) {
          /*------------------------------------------------*/
          /* Compile all inventory option objects to create */
          /* the list of implemented item master options    */
          /*------------------------------------------------*/
          var options = [];
          resp.data.forEach(function (ip) {
            options = options.concat(ip.options);
          });

          mInventoryColumn.setMasterOptions(
            Tools.mapUniqueObjects(options, 'masterOptionID', [
              { masterOptionID: 'id' },
              { masterOptionName: 'name' }
            ])
          );
        }
      });
    };

    $scope.init();
  }

  /*****************************************************************************
   * verify */
  /**
   * Verifies the product has multiple options that should be presented to the
   * user, then brings up a modal dialog and displays them to the user, returning
   * the items where quantity > 0 when the modal dialog is closed.
   * If the item doesn't have multiple options, it is returned and the modal is
   * not shown.
   *
   * @return         Promise to listen on. Will resolve with an object with two
   *                 properties, multi and items. If multi is true, multiple
   *                 items are being returned in the items array, if false, items
   *                 contains a single item being returned.
   *****************************************************************************/
  this.verify = function (prod) {
    var defer = $q.defer();

    BooksSvc.getInventoryProducts(prod.id).then(function (resp) {
      /*------------------------------------------------------------*/
      /* If no products come back return an empty object which      */
      /* indicates a non-inventory product, otherwise return the    */
      /* only product definition when there are no option products. */
      /*------------------------------------------------------------*/
      if (resp.data.length <= 1)
        defer.resolve({ multi: false, items: resp.data.shift() || {} });
      else
        $uibModal
          .open({
            animation: true,
            backdrop: 'static',
            controller: inventoryProductsController,
            resolve: {
              prod: function () {
                return prod;
              }
            },
            size: 'lg',
            template: inventoryProductsTemplate
          })
          .result.then(function (items) {
            defer.resolve({ multi: true, items: items });
          }, defer.reject);
    });

    return defer.promise;
  };
}
